import axios from 'axios'
import { Toast } from 'vant'
const ajax = axios.create()
// 拦截器
let toast = ''
const shouldShowLoading = (config) => !config || config.hideLoading !== true
const isWechatBrowser = () => /micromessenger/i.test((window.navigator.userAgent || '').toLowerCase())
const getCurrentPath = () => {
  const path = window.location.pathname.replace(/^\/p/, '') || '/home'
  const query = window.location.search || ''
  return `${path}${query}`
}
const redirectWechatBlankpage = () => {
  const currentpath = getCurrentPath()
  window.location.replace(`/p/blankpage?currentpath=${encodeURIComponent(currentpath)}`)
}
ajax.interceptors.request.use(config => {
  if (shouldShowLoading(config)) {
    toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '加载中...'
    })
  } else {
    toast = null
  }
  return config
}, err => {
  return Promise.reject(err)
})
//添加请求头
ajax.interceptors.response.use(resp => {
  if (toast && typeof toast.clear === 'function') {
    toast.clear()
  }
  toast = null
  return resp.data
}, err => {
  if (toast && typeof toast.clear === 'function') {
    toast.clear()
  }
  toast = null
  if (err && err.response && err.response.status === 401) {
    window.sessionStorage.removeItem('Token')
    window.sessionStorage.removeItem('user')
    window.sessionStorage.removeItem('openId')
    if (isWechatBrowser()) {
      redirectWechatBlankpage()
      return Promise.reject(err)
    }
    if (window.location.pathname !== '/p/Login') {
      window.location.href = '/p/Login'
    }
  }
  return Promise.reject(err)
})
//登陆
export const getToLogin = (data) => {
  return ajax.post('https://www.cnweipu.com/api/v1/authorizations', data)
}
//检测系统的分类
export const getjcList = () => {
  return ajax.get('https://www.cnweipu.com/api/v1/categories')
}
//提交上传文件
export const getToUpload = (data) => {
  return ajax.post('https://www.cnweipu.com/api/v1/orders', data, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//粘贴上传文件
export const getTopaste = (data) => {
  return ajax.post('https://www.cnweipu.com/api/v1/orders', data, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//查看报告列表
export const getReport = (data) => {
  return ajax.get(`https://www.cnweipu.com/api/v1/orders?page=${data}`, {
    hideLoading: true,
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
// 订单详情
export const getOrderDetail = (id) => {
  return ajax.get(`https://www.cnweipu.com/api/v1/orders/${id}`, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//注册
export const getToRegister = (data) => {
  return ajax.post('https://www.cnweipu.com/api/v1/users', data)
}
//验证码
export const getCode = (data) => {
  return ajax.post('https://www.cnweipu.com/api/v1/verificationCodes', data)
}
//发送邮件
export const getToEmail = (data, params) => {
  return ajax.post(`https://www.cnweipu.com/api/v1/orders/${data}/mail_report`, params, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//上传文件
export const getFileId = (data) => {
  return ajax.post('https://www.cnweipu.com/api/v1/files', data, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token"),
      "content-type": "multipart/form-data;charset=UTF-8",
    }
  })
}
//分享图片
export const getQrCode = (data) => {
  return ajax.get(`https://www.cnweipu.com/api/v1/qcrode/generate_img?title=${data.title}&writer=${data.writer}&category_name=${data.bbname}&created_at=${data.tjtime}&rate=${data.rate}`, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//微信内置浏览器支付
export const getTowxPay = (data) => {
  return ajax.get(`https://www.cnweipu.com/api/v1/payments/${data.id}/bridge_data?openid=${data.openid}&code=${data.code}`, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//获取OPenID
export const getOpenId = (data) =>{
  return ajax.get(`https://www.cnweipu.com/api/v1/payments/get_openid?code=${data.code}`,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//新的登录
export const getLogin = (data) =>{
  return ajax.post(`https://www.cnweipu.com/api/v1/socials/wechat/authorizations`,data)
}
//免登陆查手机号
export const getNoLoginOrder=(data)=>{
  return ajax.get(`https://www.cnweipu.com/api/v1/mini-orders?phone=${data}`)
}
//免登陆分享图片
export const getNoQrCode = (data) => {
  return ajax.get(`https://www.cnweipu.com/api/v1/qcrode/min-generate-img?title=${data.title}&writer=${data.writer}&category_name=${data.bbname}&created_at=${data.tjtime}&rate=${data.rate}`, {
  })
}
//免登陆发送邮件
export const getNoToEmail = (data, params) => {
  return ajax.post(`https://www.cnweipu.com/api/v1/orders/${data}/send-mail`, params)
}
//删除订单
export const deleteOrder = (data) => {
  return ajax.delete(`https://www.cnweipu.com/api/v1/orders?ids[]=${data}`,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//查询号码
export const getIsPhone = (data)=>{
  return ajax.get(`https://www.cnweipu.com/api/v1/check-order/${data}`)
}
//免费支付
export const freePay = (data) => {
  return ajax.get(`https://www.cnweipu.com/api/v1/payments/${data}/pay-by-free`, {
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token")
    }
  })
}
//PDF预查看
export const isPDF = (data)=>{
  return  ajax.get(`https://www.cnweipu.com/pdf/${data}.pdf`,{
    headers:{
      "content-type":"application/pdf"
    }
  })
}
//验证报告
export const yzOrder = (params) =>{
  return ajax.post(`https://www.cnweipu.com/api/v1/verification-report`, params)
}
//vip卡券激活
export const getVipRequst = (data)=>{
  return ajax.post(`https://www.cnweipu.com/api/v1/coupon-codes/active-coupon-code`,data,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token"),
    }
  })
}
//查看卡券

export const getMyCard = (id)=>{
  return ajax.get(`https://www.cnweipu.com/api/v1/user`,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token"),
    }
  })
}
//换取用户
export const getUserInfo = ()=>{
  return ajax.get(`https://www.cnweipu.com/api/v1/user`,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token"),
    }
  })
}
//选择卡券后计算价格
export const countPrice=(id,code)=>{
  return ajax.get(`https://www.cnweipu.com/api/v1/orders/${id}/coupon-price?code=${code}`,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token"),
    }
  })
}
//激活入口激活VIP
export const activeVip=()=>{
  return ajax.get(`https://www.cnweipu.com/api/v1/active-vip`,{
    headers: {
      Authorization: "Bearer " + window.sessionStorage.getItem("Token"),
    }
  })
}
